import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as GlobalVariables from '../../global';


@Injectable({
    providedIn: 'root'
  })
  export class GeneralService {
  
    constructor(private httpC: HttpClient) { }
     
  
    demoReqinfo(obj: any) {
        // let headers = new HttpHeaders();
        return this.httpC.post(GlobalVariables.demoReqinfo,obj);
        
      }


      addInstitution(obj: any){
        return this.httpC.post(GlobalVariables.addInstitution,obj);
      }

      contactUs(obj: any){
        return this.httpC.post(GlobalVariables.contactUs,obj);
      }

    
        getModuleList() {
          return this.httpC.get(GlobalVariables.getModuleList);
        }

        fileUpload(fileObject: any) {
          return this.httpC.post(GlobalVariables.fileUpload, fileObject);
        }
      
        getNewsList(obj: { days: string; })
        {
          return this.httpC.get(GlobalVariables.getNewsList+"?days="+obj.days);
        }

        getNewsById(obj: { id: string; })
        {
          return this.httpC.get(GlobalVariables.getNewsById+"/"+obj.id);
        }

        getNewsByCate(obj: { cateId: string; noOfNews: string; })
        {
          return this.httpC.get(GlobalVariables.getNewsByCate+"/"+obj.cateId+"?numberOfnews="+obj.noOfNews);
        }

        addLeadReq(obj:any)
        {
          return this.httpC.post(GlobalVariables.addLeadReq,obj);
        }

        getFaqList(obj: { status: any; })
        {
          return this.httpC.get(GlobalVariables.getFaqByStatus+"?status="+obj?.status);
        }

        getSchoolIdByUrl(hostname:any)
        {
          return this.httpC.get(GlobalVariables.getSchooByUrl+"?webUrl="+hostname);
        }
      
  }
